<template>
    <span class="tag is-white" :class="getPaymentTagClass">
        <span class="icon">
            <i class="fa fa-dollar-sign" />
        </span>
        <span>
            {{ getPaymentStatusText }}
        </span>
    </span>
</template>

<script>
    import { PAYMENT_AT_LEAST_ONE_COMPLETE, PAYMENT_AT_LEAST_ONE_MISSING, PAYMENT_NONE } from "../createNotification";
    import translatorMixin from "../../Common/translatorMixin";

    export default {
        name: "payment-status-tag",
        mixins: [translatorMixin],
        props: ["paymentStatus"],
        computed: {
            getPaymentStatusText() {
                if (this.paymentStatus === PAYMENT_NONE) {
                    return this.translate("notification_center.payments_filter.choose_all");
                }
                if (this.paymentStatus === PAYMENT_AT_LEAST_ONE_COMPLETE) {
                    return this.translate("notification_center.payments_filter.at_least_one_complete");
                }
                if (this.paymentStatus === PAYMENT_AT_LEAST_ONE_MISSING) {
                    return this.translate("notification_center.payments_filter.at_least_one_missing");
                }

                return "---";
            },
            getPaymentTagClass() {
                if (this.paymentStatus === PAYMENT_NONE) {
                    return "is-info";
                }
                if (this.paymentStatus === PAYMENT_AT_LEAST_ONE_COMPLETE) {
                    return "is-success";
                }
                if (this.paymentStatus === PAYMENT_AT_LEAST_ONE_MISSING) {
                    return "is-danger";
                }

                return "";
            },
        },
    };
</script>

<style scoped></style>
